function IconMoneyBag({
  color = 'currentColor',
  size = 24,
}: {
  color?: string;
  size?: number;
}) {
  return (
    <svg width={size} height={size} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.1667 3H15.1667C15.5646 3 15.9461 3.15804 16.2274 3.43934C16.5087 3.72064 16.6667 4.10218 16.6667 4.5C16.6667 5.42826 16.298 6.3185 15.6416 6.97487C14.9852 7.63125 14.095 8 13.1667 8H12.1667C11.2385 8 10.3483 7.63125 9.69187 6.97487C9.0355 6.3185 8.66675 5.42826 8.66675 4.5C8.66675 4.10218 8.82478 3.72064 9.10609 3.43934C9.38739 3.15804 9.76892 3 10.1667 3Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M4.66675 17V16C4.66675 13.8783 5.5096 11.8434 7.00989 10.3431C8.51018 8.84285 10.545 8 12.6667 8C14.7885 8 16.8233 8.84285 18.3236 10.3431C19.8239 11.8434 20.6667 13.8783 20.6667 16V17C20.6667 18.0609 20.2453 19.0783 19.4952 19.8284C18.745 20.5786 17.7276 21 16.6667 21H8.66675C7.60588 21 6.58847 20.5786 5.83832 19.8284C5.08818 19.0783 4.66675 18.0609 4.66675 17Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

IconMoneyBag.displayName = 'IconMoneyBag';

export default IconMoneyBag;
